export default {"src":"/_next/static/media/mary-kay-logotype-dark.b372b21e.svg","height":80,"width":565,"blurWidth":0,"blurHeight":0};